import { addWeeks, parse, startOfWeek } from 'date-fns';

export const convertStringDateToUnixTimestamp = (input: string) => {
  if (!input) throw new Error('Invalid input');

  const weekFormatRegex = /^Week\s+(\d{1,2})\s+(\d{4})$/;
  const match = RegExp(weekFormatRegex).exec(input);
  const normalizedInput = match ? `W${match[1]}-${match[2].slice(-2)}` : input.replace(/Week\s*/, 'W');

  const parts = normalizedInput.split(/[-\s]+/);
  const isWeekFormat = parts[0].startsWith('W');

  return isWeekFormat ? parseWeekFormat(parts) : parseMonthFormat(parts);
};

const parseWeekFormat = ([weekPart, yearSuffix]: string[]) => {
  if (!weekPart || !yearSuffix) throw new Error('Invalid week format');

  const weekNumber = parseInt(weekPart.slice(1), 10);
  const year = 2000 + parseInt(yearSuffix, 10);
  if (isNaN(weekNumber) || isNaN(year)) throw new Error('Invalid week format');

  const startOfYear = new Date(Date.UTC(year, 0, 1));
  const startOfSpecifiedWeek = addWeeks(startOfWeek(startOfYear, { weekStartsOn: 1 }), weekNumber - 1);
  return startOfSpecifiedWeek.getTime();
};

const parseMonthFormat = ([monthName, yearSuffix]: string[]) => {
  if (!monthName || !yearSuffix) throw new Error('Invalid month format');

  let year = parseInt(yearSuffix, 10);
  if (isNaN(year)) throw new Error('Invalid month format');
  if (yearSuffix.length === 2) {
    year += 2000;
  }

  const formats = ['MMM yyyy', 'MMMM yyyy'];
  for (const format of formats) {
    const date = parse(`${monthName} ${year}`, format, new Date());
    if (!isNaN(date.getTime())) {
      return date.getTime();
    }
  }

  throw new Error('Invalid date format');
};
